import { Component } from "@angular/core";
import { AppConfig } from "../../app/shared/config";
import { FnolService } from '../features/fnol/services/fnol.service';
import { Router } from "@angular/router";
import { FOOTERMAPPING } from "../features/fnol/config/footer-links-constants";
import { CacheService } from "../shared/services/cache.service"

@Component({
  selector: "cdp-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  fnolCheck = true;
  url = "supported";
  country: string | null | undefined = window.location.pathname.split('/')[3];
  selectedLanguage: string | undefined;
  regularFooterLinks: any[] = [];
lastFooterLink: any = null;
  footerLinks: { label: string; link: string }[] = [
    {
      "label": "Terms Of Use",
      "link": "https://www.aig.com/terms-of-use"
    },
    {
      "label": "Privacy",
      "link": "https://www.aig.com/global-privacy-policy"
    },
    {
      "label": "Legal Notice",
      "link": "https://www.aig.com/legal-notice"
    }
  ];
  copyrightText: string = `Copyright © ${new Date().getFullYear()} American International Group, Inc. All rights reserved.`;
  disclaimerText: string = "American International Group, Inc. (AIG) is a leading global insurance organization. AIG member companies offer insurance solutions that help businesses and individuals in approximately 70 countries and jurisdictions protect their assets and manage risks. AIG common stock is listed on the New York Stock Exchange.";

  constructor(
    public config: AppConfig,
    private fnolService: FnolService,
    public cache: CacheService,
    public router: Router,

  ) {

  }

  ngOnInit(): void {
    if (!this.cache.getCountry()) {
      const country = window.location.pathname.split('/')[2];
      const language = window.location.pathname.split('/')[3];
      if (country && language) {
        this.updateFooter(country, language)
      }

    }
    this.fnolService.landingSelectedCountry.subscribe(selectedCountry => {
      if (selectedCountry && AppConfig.countryConfig[selectedCountry.code.toLowerCase()]) {
        const country = selectedCountry.code.toLowerCase();
        const language = this.cache.getLanguage();
        this.updateFooter(country, language)
      }
    });
  }

  updateFooter(country, language='en') {
    const footerLink = FOOTERMAPPING().list;
    this.footerLinks = footerLink[country]['footer']['links'];
const specialCountries = ['de', 'at', 'ch', 'us','ca'];
  if (specialCountries.includes(country.toLowerCase())) {
    this.regularFooterLinks = this.footerLinks.slice(0, -1); // All links except last
    this.lastFooterLink = this.footerLinks[this.footerLinks.length - 1]; // Last link
  } else {
    this.regularFooterLinks = this.footerLinks;
    this.lastFooterLink = null;
  }

    this.copyrightText = footerLink[country]['footer']['copyrightText'].replace(/© \d{4}/, `© ${new Date().getFullYear()}`);
    this.disclaimerText = footerLink[country]['footer']['disclaimerText'];
    this.url = `supported/${country}/${language}`
  }

  handleFooterClick(country: any): void {
    if (country.action === 'openNotificationModal') {
      this.fnolService.notificationObligationsModal.next(true);
    } else if (country.link) {
      this.handleClick(country.link);
    }
  }

  // moving below code from app component to footer component to fix the cookie policy link issue in footer.
  // now the cdp-footer will always be available for any external script trying to access it
/**
   * Check if country and language are both selected based on URL pattern
   * URL patterns: /landing/[country]/[language] or /cdp-lite/[country]/[language]
   * Examples: /landing/es/en, /cdp-lite/es/en
   * Generated by AIG Copilot
   */
  isCountryLanguageSelected(): boolean {
   // const urlParts = this.router.url.split('/').filter(part => part); // Remove empty parts
    const urlParts=  window.location.pathname.split('/').filter(part => part); // Remove empty parts
    // Check if URL matches pattern: landing/[country]/[language] OR cdp-lite/[country]/[language]
    if (urlParts[0]==="feedback")
    {
      return true;
    }

   else if ( urlParts.length >= 3 ) {
      const country = urlParts[1];
      const language = urlParts[2];
      
      // Validate that country and language are not empty and have reasonable lengths
      return country && language && 
             country.length >= 2 && language.length >= 2 &&
             /^[a-zA-Z]+$/.test(country) && /^[a-zA-Z]+$/.test(language);
    } 
    return false;
  }
  handleClick(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  linkForRecommended() {
    window.open(this.url, '_blank');
  }

}
